export const START_TIME = 1;
export const END_TIME = 2;



// WEBPACK FOOTER //
// ./scripts/constants/timelineFocusPoints.js